import { Controller } from "@hotwired/stimulus"

// Displays a live countdown timer to a given end time
export default class extends Controller {
  static values = {
    end: String,
    expiredLabel: { type: String, default: "Expired" }
  }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    const end = new Date(this.endValue)
    const now = new Date()
    const diff = end - now

    if (diff <= 0) {
      this.element.textContent = this.expiredLabelValue
      this.element.classList.add("text-red-500")
      clearInterval(this.timer)
      return
    }

    const minutes = Math.floor(diff / 60000)
    const seconds = Math.floor((diff % 60000) / 1000)
    this.element.textContent = `${minutes}m ${seconds.toString().padStart(2, "0")}s`
  }
}
